export const ACCOUNTING_BILL_STATUS_REFUTE_HST = "refute_hst"
export const ACCOUNTING_BILL_STATUS_REFUTE_OTHER = "refute_other"
